export const SERVICE_PACKAGE = 'SERVICE_PACKAGE';

export const PACKAGE = 'PACKAGE';
